/**
 * Centralized A/B Test Configuration
 *
 * This file contains all A/B test configurations for easy management
 * and centralized control of feature rollouts.
 */

export const AB_TEST_CONFIG = {
  CONTACT_SALES: {
    enabled: true,
    rolloutPercentage: 50, // 50% of users (even recruiter IDs)
    feature: "CONTACT_SALES",
    description: "New contact sales form with improved UX"
  }

  // Future A/B tests can be added here
  // Example configuration for future A/B tests:
  //
  // NEW_FEATURE_TEST: {
  //   enabled: false,
  //   rolloutPercentage: 25,
  //   feature: 'NEW_FEATURE_V2',
  //   description: 'Testing new feature implementation',
  // }
};

export default AB_TEST_CONFIG;
